import React, { useEffect, useState } from "react";
import "../css/Notification.css";
import CuCheckbox from "../../common_component/component/CuCheckbox";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { useAtom } from "jotai";
import { useSecureUpdateItem } from "../../_helper/actions/mutation/items";
import { toast } from "react-toastify";

const NotificationSetup = () => {
  const [clinic] = useAtom(clinicAtom);

  const [formData, setFormData] = useState([]);

  const {
    data: notificationData,
    isLoading,
    isFetched,
  } = useItemsFilter(
    ApiEndPoint.MEDICINE_TAG_DATA,
    `?action=getNotificationCategory&clinic_id=${clinic.id}`,
    clinic ? true : false
  );

  const updateNotification = useSecureUpdateItem(
    ApiEndPoint.NOTIFICATION,
    ApiEndPoint.MEDICINE_TAG_DATA
  );
  const createNotification = useSecureUpdateItem(
    ApiEndPoint.NOTIFICATION,
    ApiEndPoint.MEDICINE_TAG_DATA
  );

  // //(notificationData);

  useEffect(() => {
    if (isFetched) {
      const updatedFormData = notificationData?.flatMap((module) =>
        module.notification_names?.map((notification) => ({
          name: notification?.name,
          id: notification.id,
          is_sms: notification.notification_allowance.is_sms,
          is_email: notification.notification_allowance.is_email,
          is_whatsapp: notification.notification_allowance.is_whatsapp,
          clinic_id: clinic.id,
        }))
      );

      //(updatedFormData);
      setFormData((prevFormData) => [...prevFormData, ...updatedFormData]);
    }
  }, [isFetched]);

  //("Forma Data", formData);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="w-full">
      {notificationData?.map((module, moduleIndex) => (
        <div key={module.id} className="w-full mb-6">
          <div className="text-lg my-2">{module.name}</div>
          <div className="cu-notification-table w-full">
            <table className="w-full">
              <thead className="cu-notification-table-header">
                <tr>
                  <th>Module Subsection</th>
                  <th>SMS</th>
                  <th>Email</th>
                  <th>WhatsApp</th>
                </tr>
              </thead>
              <tbody>
                {module.notification_names?.map((notification) => {
                  // //(notification);
                  // setFormData([
                  //   ...formData,
                  //   {
                  //     name: notification?.name,
                  //     id: notification.id,
                  //     is_sms: notification.notification_allowance.is_sms,
                  //     is_email: notification.notification_allowance.is_email,
                  //     is_email: notification.notification_allowance.is_whatsapp,
                  //     clinic_id: clinic.id,
                  //   },
                  // ]);
                  return (
                    <tr key={notification.id}>
                      <td>{notification.name}</td>
                      <td className="">
                        <div>
                          <CuCheckbox
                            label={"Allow"}
                            name={notification?.name}
                            defaultChecked={
                              notification?.notification_allowance.is_sms
                            }
                            onChange={(e) => {
                              const action = notification
                                ?.notification_allowance?.id
                                ? "patchNotificationAllowance"
                                : "postNotificationAllowance";
                              let payload = {
                                action,
                                is_sms: e.target.checked,
                                notification_name_id:
                                  notification.notification_allowance
                                    .notification_name_id,
                                clinic_id: clinic.id,
                                id: notification.notification_allowance.id,
                              };
                              if (notification?.notification_allowance?.id) {
                                updateNotification.mutate(
                                  { data: payload },
                                  {
                                    onSuccess: () => {
                                      e.target.checked
                                        ? toast.success("SMS Service Enable!")
                                        : toast.success(
                                            "SMS Service Disabled!"
                                          );
                                    },
                                  }
                                );
                              }
                              setFormData([
                                ...formData,
                                {
                                  name: notification?.name,
                                  notification_name_id:
                                    notification.notification_allowance
                                      .notification_name_id,
                                  is_sms: e.target.checked,
                                  clinic_id: clinic.id,
                                },
                              ]);
                            }}

                            // checked={notification.notification_allowance.is_sms}
                            // checked={false}
                          />
                        </div>
                      </td>
                      <td className="">
                        <div>
                          <CuCheckbox
                            label={"Allow"}
                            // checked={
                            //   notification.notification_allowance.is_email
                            // }
                            name={notification?.name}
                            defaultChecked={
                              notification?.notification_allowance.is_email
                            }
                            onChange={(e) => {
                              const action = notification
                                ?.notification_allowance?.id
                                ? "patchNotificationAllowance"
                                : "postNotificationAllowance";
                              let payload = {
                                action,
                                is_email: e.target.checked,
                                notification_name_id:
                                  notification.notification_allowance
                                    .notification_name_id,
                                clinic_id: clinic.id,
                                id: notification.notification_allowance.id,
                              };
                              if (notification?.notification_allowance?.id) {
                                updateNotification.mutate(
                                  { data: payload },
                                  {
                                    onSuccess: () => {
                                      e.target.checked
                                        ? toast.success("Email Service Enable!")
                                        : toast.success(
                                            "Email Service Disabled!"
                                          );
                                    },
                                  }
                                );
                              }
                              setFormData([
                                ...formData,
                                {
                                  name: notification?.name,
                                  notification_name_id:
                                    notification.notification_allowance
                                      .notification_name_id,
                                  is_email: e.target.checked,
                                  clinic_id: clinic.id,
                                },
                              ]);
                            }}
                          />
                        </div>
                      </td>
                      <td className="">
                        <div>
                          <CuCheckbox
                            label={"Allow"}
                            // checked={
                            //   notification.notification_allowance.is_whatsapp
                            // }
                            name={notification?.name}
                            defaultChecked={
                              notification?.notification_allowance.is_whatsapp
                            }
                            onChange={(e) => {
                              const action = notification
                                ?.notification_allowance?.id
                                ? "patchNotificationAllowance"
                                : "postNotificationAllowance";
                              let payload = {
                                action,
                                is_whatsapp: e.target.checked,
                                notification_name_id:
                                  notification.notification_allowance
                                    .notification_name_id,
                                clinic_id: clinic.id,
                                id: notification.notification_allowance.id,
                              };
                              if (notification?.notification_allowance?.id) {
                                updateNotification.mutate(
                                  { data: payload },
                                  {
                                    onSuccess: () => {
                                      e.target.checked
                                        ? toast.success(
                                            "Whatsapp Service Enable!"
                                          )
                                        : toast.success(
                                            "Whatsapp Service Disabled!"
                                          );
                                    },
                                  }
                                );
                              }
                              setFormData([
                                ...formData,
                                {
                                  name: notification?.name,
                                  notification_name_id:
                                    notification.notification_allowance
                                      .notification_name_id,
                                  is_whatsapp: e.target.checked,
                                  clinic_id: clinic.id,
                                },
                              ]);
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NotificationSetup;
